import { render } from "./UpdateListOrder.vue?vue&type=template&id=4a417478&scoped=true"
import script from "./UpdateListOrder.vue?vue&type=script&lang=js"
export * from "./UpdateListOrder.vue?vue&type=script&lang=js"

import "./UpdateListOrder.vue?vue&type=style&index=0&id=4a417478&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a417478"]])

export default __exports__